// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"4cc06ddb","194":"568481e2","822":"5c4eaf5b"}[chunkId] + ".chunk.css";
};